import { render, staticRenderFns } from "./list-tpl.vue?vue&type=template&id=0fa82fa9&scoped=true"
import script from "./list-tpl.vue?vue&type=script&lang=js"
export * from "./list-tpl.vue?vue&type=script&lang=js"
import style0 from "./list-tpl.vue?vue&type=style&index=0&id=0fa82fa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa82fa9",
  null
  
)

export default component.exports